import React, { useRef } from 'react'
import styels from './HomeFourth.module.css'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'
gsap.registerPlugin(ScrollTrigger)
const images = require.context(`../../asssists/videos`,true);
const imagesList = images.keys().map((image) => images(image))

export default function HomeFourth() {
 let section=useRef();
 let horizontalSection=useRef();
  
useGSAP(() => {
  gsap.to('#horizontal', {
    x: () => horizontalSection.current.scrollWidth * -1,
    xPercent: 100,
    scrollTrigger: {
      trigger: '#horizontal',
      start: 'center center',
      end: "+=" + section.current.offsetWidth,
      pin: '#horizontal-scoll',
      scrub: 3,
      invalidateOnRefresh: true,
      snap:1 / (horizontalSection),

    }
  });
},[section])


  




  return (
    <>
   <section ref={section} id="horizontal-scoll" className={styels.HomeFourth}>
   <h3 className='text-center mb-5'>We Bring Your Bussnies to The Next Level</h3>
  <div className="horizontal-scoll-wrapper">
    <div id='horizontal' ref={horizontalSection} className={styels.horizontal}>
      <div>
        {imagesList.map((image, index) => (
          <div key={index} className={styels.jsCatcch}>
          <video  src={image} alt="" autoPlay loop muted />
          <div className={styels.content}>
            <h3>Pirate Cat</h3>
            <p>This Cat Get Every Thing He wants From The Sea</p>
          </div>
        </div>
        ))}
     
    
     
      
      </div>
     
      
      
      
    </div>
  </div>
</section>

    </>
  )
}

